import { IF, UIView } from "uicore-ts"
import { RHSpacing } from "./Utils_slop/RHDesignTokens"


/**
 * RHVerticalStackView — stacks its subviews top-to-bottom as a single column,
 * separated by `rowGap`. Because it lays its children out from its own content
 * bounds, the framework derives its height automatically via virtual layout, so it
 * can be dropped into any rectangle-chain (or used as an RHLabeledRow value) and
 * measured without manual height bookkeeping.
 */
export class RHVerticalStackView extends UIView {

    rowGap: number = RHSpacing.tiny

    constructor(elementID?: string) {
        super(elementID)
    }

    override layoutSubviews() {
        super.layoutSubviews()
        this.contentBoundsWithInset(0).framesByDistributingViewsAsColumn(this.subviews, this.rowGap)
    }


    /**
     * A stack's height is the current sum of its rows, not a snapshot of the
     * frames produced by an earlier virtual layout. Child content can settle
     * after the stack was first measured (for example, text or async labels),
     * so deriving this value directly keeps every parent measurement in sync.
     */
    override intrinsicContentHeight(constrainingWidth = 0): number {
        const contentWidth = [0, constrainingWidth].max()
        return this.subviews.reduce((height, view, index) =>
            height +
            IF(index > 0)(() => this.rowGap).ELSE(() => 0) +
            view.intrinsicContentHeight(contentWidth),
        0)
    }

}
